import React, { Component } from 'react';
import {
    Form, Radio, Checkbox, Button, Row, Col,
} from 'antd';

const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;

class UnwrappedCustom extends Component {
    state = {
        value: '',
    };

    handleChange = (e) => {
        this.setState({ value: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { form, handleDoseFrequency, changeActiveKey } = this.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.handleFinal(values);
            handleDoseFrequency(values);
            changeActiveKey('4');
        });
    }

    handleFinal = (values) => {
        if (values.type === 1) {
            values.month_days = values.month_days.join('#');
            values.week_days = null;
        } else {
            values.week_days = values.week_days.join('#');
            values.month_days = null;
        }
        values.frequency = 0;
        delete values.type;
        // console.log(values);
    }

    render() {
        const { form, data, changeActiveKey } = this.props;
        const { month_days, week_days } = data;

        // console.log(month_days);
        // console.log(month_days.split('#'));
        // console.log(month_days.split('#').join(','));

        const { getFieldDecorator, getFieldValue } = form;
        const date = [
            '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15',
            '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
            '30', '31',
        ];
        const dateOptions = date.map(
            d => (
                <Col key={d} span={2} style={{ padding: '5px' }}>
                    <Checkbox key={d} value={d}>{d}</Checkbox>
                </Col>
            ),
        );

        const day = ['M', 'T', 'W', 'TH', 'F', 'S', 'SU'];
        const dayOptions = day.map(
            d => (
                <Col key={d} span={3}>
                    <Checkbox key={d} value={d}>{d}</Checkbox>
                </Col>
            ),
        );

        const selectedDateOptions = [];
        const selectedDayOptions = [];

        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <FormItem>

                        {getFieldDecorator('type', {
                            rules: [{ required: true, message: 'Please select a start date!' }],
                            initialValue: month_days === '' ? 2 : 1,
                        })(
                            <RadioGroup name="radiogroup" onChange={this.handleChange}>

                                <Row type="flex" justify="space-around">
                                    <Col span={12}>
                                        <Radio style={{ display: 'block' }} value={1}>By Date</Radio>
                                    </Col>
                                    <Col span={12}>
                                        <Radio style={{ display: 'block' }} value={2}>By Day</Radio>
                                    </Col>
                                </Row>

                            </RadioGroup>,
                        )}

                        {/* <RadioGroup name="radiogroup" onChange={this.handleChange}>

                            <Row type="flex" justify="space-around">
                                <Col span={12}>
                                    <Radio style={{ display: 'block' }} value={1}>By Date</Radio>
                                </Col>
                                <Col span={12}>
                                    <Radio style={{ display: 'block' }} value={2}>By Day</Radio>
                                </Col>
                            </Row>

                        </RadioGroup> */}
                    </FormItem>

                    <Row type="flex" justify="center">

                        <Col span={12}>
                            <FormItem>
                                {getFieldDecorator('month_days', {
                                    // initialValue: selectedDateOptions.map( opt => opt && opt ),
                                    rules: [{ type: 'array', required: false, message: 'Please select!' }],
                                    initialValue: month_days == null
                                        ? selectedDateOptions.map(opt => opt && opt)
                                        : month_days.split('#'),
                                })(
                                    <CheckboxGroup disabled={getFieldValue('type') !== 1}>
                                        <Row style={{ paddingLeft: '30px' }}>
                                            {dateOptions}
                                        </Row>
                                    </CheckboxGroup>,
                                )}
                            </FormItem>
                        </Col>

                        <Col span={12}>
                            <FormItem>
                                {getFieldDecorator('week_days', {
                                    // initialValue: selectedDayOptions.map( opt => opt && opt ),
                                    rules: [{ type: 'array', required: false, message: 'Please select!' }],
                                    initialValue: week_days == null
                                        ? selectedDayOptions.map(opt => opt && opt)
                                        : week_days.split('#'),
                                })(
                                    <CheckboxGroup disabled={getFieldValue('type') !== 2}>
                                        <Row>
                                            {dayOptions}
                                        </Row>
                                    </CheckboxGroup>,
                                )}
                            </FormItem>
                        </Col>

                    </Row>


                    <Row type="flex" justify="center" style={{ marginTop: '5%' }}>
                        <Col span={12}>
                            <FormItem>
                                <Button type="primary" onClick={() => changeActiveKey('2')}>To Prev</Button>
                            </FormItem>
                        </Col>

                        <Col span={12}>
                            <FormItem>
                                <Button type="primary" htmlType="submit">To Next</Button>
                            </FormItem>
                        </Col>
                    </Row>

                </Form>

            </div>
        );
    }
}

const Custom = Form.create()(UnwrappedCustom);
export default Custom;



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/DoseFrequencyHelper/Custom.js